var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShow = function SvgShow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.79492C10.2299 8.79492 8.79492 10.2299 8.79492 12C8.79492 13.7701 10.2299 15.2051 12 15.2051C13.7701 15.2051 15.2051 13.7701 15.2051 12C15.2051 10.2299 13.7701 8.79492 12 8.79492ZM10.2949 12C10.2949 11.0583 11.0583 10.2949 12 10.2949C12.9417 10.2949 13.7051 11.0583 13.7051 12C13.7051 12.9417 12.9417 13.7051 12 13.7051C11.0583 13.7051 10.2949 12.9417 10.2949 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.25C8.09116 4.25 4.69816 6.77485 2.60418 8.77933C0.798606 10.5077 0.798607 13.4923 2.60418 15.2207C4.69816 17.2252 8.09116 19.75 12 19.75C15.9088 19.75 19.3018 17.2252 21.3958 15.2207C23.2014 13.4923 23.2014 10.5077 21.3958 8.77933C19.3018 6.77485 15.9088 4.25 12 4.25ZM3.64143 9.8629C5.67507 7.91618 8.70043 5.75 12 5.75C15.2996 5.75 18.3249 7.91618 20.3586 9.8629C21.5471 11.0007 21.5471 12.9993 20.3586 14.1371C18.3249 16.0838 15.2996 18.25 12 18.25C8.70043 18.25 5.67507 16.0838 3.64143 14.1371C2.45286 12.9993 2.45286 11.0007 3.64143 9.8629Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "show.1311010fdc5b0a7a89a1bfe26af1b1ba.svg";